import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Response, Headers } from '@angular/http';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { Contrato } from '../modelo/contrato';
import { EfetivarEnderecoRequest, Endereco } from '../modelo/endereco';
import { SessaoService } from './sessao.service';
import { Cliente } from '../modelo/cliente';
import { Cep } from '../modelo/cep';
import { EnderecoLogradouro } from '../modelo/enderecoLogradouro';

@Injectable()
export class EnderecoService {

    constructor(
        private restClient: RestClientService,
        private sessaoService: SessaoService
    ) {

    }

    listarContrato = (): Observable<Cliente> => {
        let resourcePath = Config.ENDERECO_PATH + "/listarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarEndereco = (contrato: Contrato): Observable<Contrato> => {
        let resourcePath = Config.ENDERECO_PATH + "/recuperarEndereco";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    consultarEndereco = (cdCep: string): Observable<Cep> => {
        let resourcePath = Config.ENDERECO_PATH + "/consultarEndereco";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/cdCep/" + cdCep;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    efetivarEndereco = (nuContrato: number, dsEndereco: string, nuEndereco: number,
      dsComplemento: string, dsBairro: string, dsCidade: string, cdUf: string,
      cdCep: string): Observable<Endereco> => {
      let resourcePath = Config.ENDERECO_PATH + '/efetivarEnderecoPost';
      const request: EfetivarEnderecoRequest = {
        nuCTRL: this.sessaoService.sessao.autenticado.nuCTRL,
        nuContrato: nuContrato.toString(),
        dsEndereco: dsEndereco.trim().replace(':', ''),
        nuEndereco: nuEndereco.toString(),
        dsComplemento: dsComplemento === '' ? 'VAZIO' : dsComplemento.trim(),
        dsBairro: dsBairro.trim(),
        dsCidade: dsCidade.trim(),
        cdUf: cdUf.trim(),
        cdCep: cdCep.trim().replace('-', '')
      };
      return this.restClient.postResource(resourcePath, request);
    };

    consultarEnderecoPorLogradouro = (dsLogradouro: string, cdUf: string): Observable<EnderecoLogradouro> => {
        let resourcePath = Config.ENDERECO_PATH + "/consultarEnderecoPorLogradouro";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/dsLogradouro/" + dsLogradouro;
        resourcePath += "/cdUf/" + cdUf;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    consultarEnderecoPorLogradouro2 = (dsLogradouro: string, cdUf: string, dsCidade: string): Observable<EnderecoLogradouro> => {
        let resourcePath = Config.ENDERECO_PATH + "/consultarEnderecoPorLogradouro";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/dsLogradouro/" + dsLogradouro;
        resourcePath += "/cdUf/" + cdUf;
        resourcePath += "/dsCidade/" + dsCidade;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    consultarEnderecoPorCidade = (cdUf: string, dsCidade: string): Observable<EnderecoLogradouro> => {
        let resourcePath = Config.ENDERECO_PATH + "/consultarEnderecoPorCidade";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/cdUf/" + cdUf;
        resourcePath += "/dsCidade/" + dsCidade;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/endereco.service.ts